import { get } from "utils/request"
import { isMobile, getSearch, getStoredParams } from "../utils/utils"
import { baseUrl } from "utils/constant"

export async function getshoplink() {
  const source =  isMobile() ? 'h5' : 'pc'
  const spread = getSearch('spread') || (getStoredParams() || {}).spread
  let url = `/shop/links?source=${source}&referrer=${baseUrl}`
  if (spread) {
    url += `&spread=${spread}`
  }
  const data = await get(url, {})
  return data
}

export async function getPrice() {
  const data = await get(`/shop/router/attr`, {})
  return data
}

export async function getTagInfo() {
  const data = await get(`/internal-ads?language=zh`, {})
  return data
}
